<script lang="ts" setup>
// DataQualityLegend (DEV-595, C2) — légende des couleurs de qualité dataV2.
// Affichée sur la page de données pour expliquer le code couleur des relevés.
import { computed } from "vue"
import { useI18n } from "vue-i18n"
import {
    QUALITY,
    QUALITY_LEGEND_ORDER,
    type ProvenanceCode,
} from "./dataQuality"
import DataQualityBadge from "./DataQualityBadge.vue"

const props = withDefaults(
    defineProps<{
        /** codes à afficher (défaut : tous, ordre fiabilité). Permet de ne
         *  montrer que les provenances réellement présentes sur la période. */
        codes?: ProvenanceCode[]
        title?: string
        /** "color" (tableau) | "opacity" (graphes). */
        variant?: "color" | "opacity"
    }>(),
    { codes: () => QUALITY_LEGEND_ORDER, title: "", variant: "color" }
)

const { t } = useI18n({
    messages: { fr: { title: "Qualité de la donnée" } },
})

const shown = computed<ProvenanceCode[]>(() =>
    props.codes.filter((c) => c in QUALITY)
)
</script>

<template>
    <div
        class="data-quality-legend flex flex-wrap items-center gap-x-3 gap-y-1"
    >
        <span class="text-xs font-medium text-slate-600">
            {{ title || t("title") }} :
        </span>
        <DataQualityBadge
            v-for="code in shown"
            :key="code"
            :code="code"
            :variant="variant"
        />
    </div>
</template>
